// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"d082e8a9","325":"8b94d069"}[chunkId] + ".chunk.js";
};